import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';

import {
  ADD_TO_COMPARE_LABEL,
  ADD_TO_COMPARE_TEXT,
  COMPARE_BUTTON_DATA_MARK,
  REMOVE_FROM_COMPARE_LABEL,
  REMOVE_FROM_COMPARE_TEXT,
} from './constants';

interface ICompareButtonControlProps {
  hideText?: boolean;
  isHeader?: boolean;
  buttonTheme?: TButtonTheme;
  addToCompareText?: string;
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonControl({
  hideText = false,
  isHeader = false,
  buttonTheme,
  addToCompareText = ADD_TO_COMPARE_TEXT,
  isAdded,
  onClick,
}: ICompareButtonControlProps) {
  const theme = buttonTheme || (isHeader ? 'stroke_secondary' : 'fill_white_primary');
  const iconColor =
    isHeader || theme === 'inverted'
      ? 'icon-primary-default'
      : theme === 'stroke_secondary'
        ? 'icon-inverted-default'
        : 'icon-main-default';

  return (
    <Button
      beforeIcon={
        isAdded ? <IconActionCompareAdded16 color={iconColor} /> : <IconActionCompareAdd16 color={iconColor} />
      }
      theme={theme}
      size="M"
      onClick={onClick}
      data-mark={COMPARE_BUTTON_DATA_MARK}
      data-testid="NewbuildingCompareButton"
      aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
    >
      {hideText ? '' : isAdded ? REMOVE_FROM_COMPARE_TEXT : addToCompareText}
    </Button>
  );
}
